import { api } from "./client";
import type { SearchResponse } from "./types";

export async function search(params: {
  q: string;
  types?: string[];
  limit?: number;
  caseId?: string;
}) {
  const { data } = await api.get<SearchResponse>("/search", {
    params: {
      ...params,
      types: params.types?.join(","),
    },
  });
  return data;
}
